/**
 * Vertical nested menu.
 */
const menu_nested_vertical = (args) => {
    let menu = args.menu;

    if (!menu) {
        return;
    }

    if (!H_Tools?.nestedmenu) {
        return;
    }

    // Open current-menu-item ancestors
    const currentMenuItem = menu.querySelector('.current-menu-item');
    if (currentMenuItem) {
        const ancestors = H_Tools.ancestors.getAllAncestors(
            currentMenuItem,
            menu,
            'menu-item-has-children'
        );
        ancestors.forEach((ancestor) => {
            H_Tools?.nestedmenu?.activateMenuItem(menu, ancestor);
        });

        // Activate current menu item if it has children
        if (currentMenuItem.classList.contains('menu-item-has-children')) {
            H_Tools?.nestedmenu?.activateMenuItem(menu, currentMenuItem);
        }
    }
};

document.querySelectorAll('.js-menu-nested-vertical').forEach((menu) => {
    menu_nested_vertical({
        menu: menu,
    });
});
